import {Directive, ElementRef, Input, TemplateRef, ViewContainerRef} from '@angular/core'
import {PERMISSION} from "@generated-backend-types";
import {UserSessionService} from '../services/user-session.service';
import {ModelPermission} from '../entities/model-permission.entity';

@Directive({
  selector: '[appIfHasAllPermissions]',
  standalone: true
})
export class IfHasAllPermissionsDirective {
  public constructor(
    private readonly element: ElementRef,
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly authService: UserSessionService
  ) {}

  @Input() set appIfHasAllPermissions(permissions: (PERMISSION|ModelPermission)[]) {
    if (permissions && permissions.length > 0 && this.authService.hasAllPermission(permissions)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
